<template>
  <div class="info">
    <div class="label">{{ label }}</div>
    <div class="value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: 'InfoText',
  props: {
    label: {
      type: String,
      default: 'Email Address'
    },
    value: {
      type: String,
      default: 'example.example@gltech.xyz'
    }
  }
}
</script>

<style scoped>
.info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #091540;
  text-transform: unset;
}

.value {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(9, 21, 64, 0.68);
}
</style>
